<script setup lang="ts">
import { ProductName } from '@common/contracts';
import NavigationCard from '../../components/NavigationCard/NavigationCard.vue';
import { RoutePaths } from '../../Router/types/routePaths';
import { useUserStore } from '../../stores/userStore/userStore';
import { useRouter } from 'vue-router';

const router = useRouter();
const userStore = useUserStore();

function isCalcAcitve(name: ProductName) {
  return userStore.getUserCalculators.includes(name);
}

const goBack = () => {
  router.back();
};
</script>

<template>
  <div class="dashboard">
    <div class="dashboard__leading">
      <button
        class="dashboard__back-button"
        @click="goBack"
      >
        <i class="pi pi-arrow-left"></i>
        Powrót
      </button>
      <h1 class="dashboard__title">Witamy w Twoich kalkulatorach!</h1>
      <p class="dashboard__subtitle">Wybierz ten, który cię interesuje.</p>
    </div>
    <div>
      <div class="dashboard__card-container">
        <NavigationCard
          :image-source="'/planer-slubny.webp'"
          title="Harmonogram dnia ślubu"
          :icon="''"
          :product-name="ProductName.WEDDINGPLANER"
          :is-active="isCalcAcitve(ProductName.WEDDINGPLANER)"
          :next-page="RoutePaths.calculatorsPage"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.dashboard {
  padding: 4rem;
  min-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10rem;

  &__leading {
    line-height: 1.5;
  }

  &__back-button {
    display: inline-flex;
    align-items: center;
    gap: 0.75rem;
    padding: 1rem 2rem;
    background-color: $brown-200;
    color: white;
    border: none;
    border-radius: 0.8rem;
    font-size: 1.6rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    margin-bottom: 2rem;

    &:hover {
      background-color: rgba($brown-200, 0.9);
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba($brown-200, 0.3);
    }

    &:active {
      transform: translateY(0);
      box-shadow: 0 2px 6px rgba($brown-200, 0.2);
    }

    i {
      font-size: 1.5rem;
    }
  }

  &__title {
    color: $brown-200;
  }

  &__subtitle {
    font-size: 2.5rem;
    color: $brown-200;
    font-weight: 600;
  }

  &__card-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4rem;
    justify-content: flex-start;

    @media (min-width: $media-max-tablet) {
      flex-direction: row;
    }
  }

  &__link {
    text-decoration: none;
  }
}
</style>
